<div odxLayout="flex vertical-center horizontal-center">
  <img src="../../assets/draeger-logo.png" alt="draeger logo" class="draeger-logo" />
  <img src="../../assets/navinta_logo.svg" alt="navinta logo" class="navinta-logo" />
  <p>Navinta</p>
</div>
